<template>
    <main>
        <section class="pd">
            <div class="subtotal">
                <div class="subtotal_sticky">
                    <h3 class="head">
                        Subtotal: <span>{{ $store.state.channel.selectedChannel.currencies[0].symbol }} {{productDetails.formated_price.substring(1)}}</span>
                    </h3>
                    <div class="body">
                        <h4 class="stock">In Stock.</h4>
                        <div class="squantity">
                            Qty: 
                            <select name="" id="">
                                <option value="a">1</option>
                                <option value="a">2</option>
                                <option value="a">3</option>
                            </select>
                        </div>
                        <a class="cart_btn" @click="addCartItems(productDetails); showHideMiniCart();">
                            <img src="../assets/add_cart.svg" alt=""><span>Add to Cart</span>
                        </a>
                        <!-- <a href="#" class="cart_btn" v-if="!carats.iELightBox">
                            <img src="../assets/add_cart.svg" alt=""><span>Add to Cart</span>
                        </a> -->
                        <a href="#" class="add_wish">Add to Wishlist</a>
                        <p> <img src="../assets/lock.svg" alt=""> Payment is protected</p>
                    </div>
                </div>
            </div>
            <div class="mobile_view" v-if="false">
                <a href="#" class="mobile_view_btn">
                    <div class="mobile_view_btn_icon">
                        <img src="../assets/smartphone.svg" alt="">
                    </div>
                    <p class="mobile_view_btn_text">Mobile View</p>
                </a>   
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-5">
                      <div class="pd_images">
                            <div class="pd_images_thumb">
                              <ul class="pd_images_thumb_ul">
                                <li
                                  @mouseover="changeBigImage('mobile_first_image', $event); hideMFHotspot=true" 
                                  v-if="getValueFromObj(initialCaratSetting, 'iEMobileFirst') && productDetails.mobile_first_image"
                                  >
                                    <img :src="productDetails.mobile_first_image" alt="">
                                </li>
                                <li
                                  @mouseover="changeBigImage(productDetails.primary_image, $event); hideMFHotspot=false" 
                                  v-if="!getValueFromObj(initialCaratSetting, 'iEMobileFirst')"
                                  >
                                    <img :src="productDetails.primary_image" @error="imageUrlAlt" alt="">
                                </li>
                                <!-- v-if="carats.iEMobileFirst && productDetails.mobile_first_image" -->
                                <div v-if="getValueFromObj(initialCaratSetting, 'iESecondaryImages') && productDetails.secondary_images.length > 0">
                                  <li 
                                    v-for="(item, i) in productDetails.secondary_images.slice(0, carats.numberOfImages)" 
                                    :key="i"
                                    @mouseover="changeBigImage(item, $event); hideMFHotspot=false" 
                                  >
                                    <img :src="item" @error="imageUrlAlt" alt="">
                                  </li>
                                </div>
                                <!-- <li :data-for="`item${i+2}`" :class="i == 0 && !productDetails.mobile_first_image ? 'selected' : ''" v-for="(item, i) in productDetails.secondary_images" :key="i"><img :src="item" alt=""></li> -->
                                <li v-if="getValueFromObj(initialCaratSetting, 'iEVideo') && productDetails.secondary_video" @mouseover="showVideo = true; hideMFHotspot=false" class="video">
                                  <img :src="getVideoThumb(productDetails.secondary_video)" alt="">
                                  <i class="fa fa-play"></i>
                                </li>
                              </ul>
                              <hot-spot classValue="main-img" keyValue="secondary_images" v-if="getValueFromObj(initialCaratSetting, 'iESecondaryImages')"/>
                              <hot-spot classValue="main-video" keyValue="video" v-if="getValueFromObj(initialCaratSetting, 'iEVideo') && productDetails.secondary_video"/>
                            </div>
                            <div class="pd_images_main">
                              <ul @click="showModal = false;">
                                <li style="display: block;">
                                  <img :src="bigImage" alt="" v-if="!showVideo">
                                  <!-- <video :src="productDetails.secondary_video" v-if="showVideo"></video> -->
                                  <iframe v-if="showVideo" :src="getVideoUrl(productDetails.secondary_video)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </li>
                              </ul>
                              <hot-spot classValue="main-bigimg" keyValue="mobile_first_img" v-if="getValueFromObj(initialCaratSetting, 'iEMobileFirst') && hideMFHotspot" />
                            </div>
                            <div class="pd_images_modal" :class="showModal ? 'show': ''">
                              <div class="pd_images_modal_content">
                                <button @click="closeModal" class="pd_images_modal_content_close"><img src="../assets/modal_close.svg" alt=""></button>
                                <ul class="nav nav-tabs">
                                  <li class="active"><a data-toggle="tab" href="#video">Videos</a></li>
                                  <li><a data-toggle="tab" href="#images">Images</a></li>
                                </ul>

                                <div class="tab-content">
                                  <div id="video" class="tab-pane fade in active show">
                                    <div class="main-content">
                                      <div class="left-side">
                                        <div class="video_container">
                                          <video controls="" style="width:100%;">
                                            <source src="https://www.w3schools.com/html/movie.mp4" type="video/mp4">
                                            Your browser does not support the video tag.
                                          </video>
                                        </div>
                                      </div>
                                      <div class="right-side">
                                        <h3 class="head">Videos for this product</h3>
                                        <div class="info">
                                          <ul>
                                            <li class="video_list">
                                              <div class="video_list_thumb">
                                                <img src="../assets/gallary/1.jpg" alt="">
                                              </div>
                                              <div class="video_list_detail">
                                                <h2 class="title">
                                                   Duracell Alkaline Batteries 
                                                   <span>Merchant Video</span>
                                                </h2>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div id="images" class="tab-pane fade">
                                    <div class="main-content">
                                      <div class="left-side">
                                        <div class="img-container">
                                          <img :src="selectedImg" alt="">
                                        </div>
                                      </div>
                                      <div class="right-side">
                                        <div class="info">
                                          <div>
                                            <div class="img_list_detail">
                                            <h2 class="title">
                                                Duracell Plus AAA Alkaline Batteries (Pack of 18), 1.5 Volts LR03 MN2400 (Amazon Exclusive)
                                            </h2>
                                            <p class="cell_size">Cell size: 10500 mAH</p>
                                            <p class="pack_size">Pack size: 1 Pack</p>
                                          </div>
                                          <div class="img_thumb_list">
                                            <ul>
                                                <li :data-for="`item${i+1}`" @click="selecting(`item${i+1}`)" @mouseover="selecting(`item${i+1}`)" :class="i == 0 ? 'selected' : ''" v-for="(item, i) in productDetailList.images" :key="i"><img :src="item" alt=""></li>
                                            </ul>
                                          </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="pd_content">
                            <h1 class="pd_content_title"><span v-if="!getValueFromObj(initialCaratSetting, 'iEOptimized')">{{ productDetails.name }}</span><span v-if="getValueFromObj(initialCaratSetting, 'iEOptimized')">{{ productDetails.optimized_title }} <hot-spot keyValue="optimized_title" /></span>
                            </h1>
                            <p class="pd_content_from">From: <a href="#">{{ productDetails.brand }}</a></p>
                            <div class="pd_content_ratings" v-if="getValueFromObj(initialCaratSetting, 'iERate')">
                                <i class="fa fa-star" v-for="(item, i) in productDetails.custom_rating ? parseInt(productDetails.custom_rating): 5" :key="i"></i>
                                <a href="#">{{ productDetails.custom_review }} reviews <hot-spot keyValue="custom_review" /></a>
                            </div>
                            <div class="pd_content_price">
                                <p class="pd_content_price_mrp">RRP: <span>{{ $store.state.channel.selectedChannel.currencies[0].symbol }} {{productDetails.formated_price.substring(1)}}</span></p>
                                <p class="pd_content_price_actual">Price: <span>{{ $store.state.channel.selectedChannel.currencies[0].symbol }} {{productDetails.formated_price.substring(1)}}</span></p>
                                <p class="pd_content_price_discount">You save: <span>{{ 0 }}</span></p>
                            </div>
                            <prodct-size-and-style :changeEvent="dataChange"/>
                            <div class="mobile_total">
                                <div class="body">
                                    <h4 class="stock">In Stock.</h4>
                                    <div class="squantity">
                                        Qty: 
                                        <select name="" id="">
                                            <option value="a">1</option>
                                            <option value="a">2</option>
                                            <option value="a">3</option>
                                        </select>
                                    </div>
                                    <a class="cart_btn" @click="addCartItems(productDetails); showHideMiniCart();">
                                        <img src="../assets/add_cart.svg" alt=""><span>Add to Cart</span>
                                    </a>
                                    <!-- <a href="#" class="cart_btn" v-if="!getValueFromObj(initialCaratSetting, 'iELightBox')">
                                        <img src="../assets/add_cart.svg" alt=""><span>Add to Cart</span>
                                    </a> -->
                                    <a href="#" class="add_wish">Add to Wishlist</a>
                                    <p> <img src="../assets/lock.svg" alt=""> Payment is protected</p>
                                </div>
                            </div>
                            <div class="pd_content_style" v-if="getKeyWord(productDetails.product_type) == 'Device'">
                                <p class="pd_content_style_note">SKU: {{ productDetails.sku }}</p>
                            </div>
                            <div class="pd_content_feature" v-if="getValueFromObj(initialCaratSetting, 'iEBulletPoints')">
                                <hot-spot keyValue="bullet_points" class="bullets"/>
                                <ul>
                                    <div v-for="(item, i) in productDetails.bullet_points.slice(0, carats.numberOfBullets)" :key="i">
                                      <li v-if="item !== ''">{{item}}</li>
                                    </div>
                                </ul>
                            </div>
                            <additional-items v-if="getKeyWord(productDetails.product_type) == 'Device' && false"/>
                        </div>
                    </div>
                </div>
                <frequently-bought :productDetails="productDetails"/>
                <div class="row" v-if="getValueFromObj(initialCaratSetting, 'iEProductDesc')">
                    <div class="col-lg-12">
                        <div class="pd_details">
                            <h3 class="pd_details_title">Product Description <hot-spot keyValue="product_desc"/></h3>
                            <div class="pd_details_text" v-html="productDetails.description"> </div>
                        </div>
                    </div>
                </div>
                <rich-content :data="productDetails.rich_content_cards" :keyword="productDetails.product_type" />
                <custom-review :keyword="productDetails.product_type"/>
            </div>
        </section>
    </main>
</template>

<script>
import $ from 'jquery';
import { authComputed, authMethods } from "@/store/helpers";

import HotSpot from '@/components/HotSpot.vue';
import CustomReview from '@/components/ProductDetailComponents/CustomReview.vue';
import RichContent from '@/components/ProductDetailComponents/RichContent.vue';
import FrequentlyBought from '@/components/ProductDetailComponents/FrequentlyBought.vue';
import AdditionalItems from '@/components/ProductDetailComponents/AdditionalItems.vue';
import ProdctSizeAndStyle from '@/components/ProductDetailComponents/ProdctSizeAndStyle.vue';

export default {
  name: 'ProductDetail',
  components: {
    HotSpot,
    CustomReview,
    RichContent,
    FrequentlyBought,
    AdditionalItems,
    ProdctSizeAndStyle,
  },
  computed: {
      ...authComputed,
      imageNum() {
        return {
          a: this.getValueFromObj(this.initialCaratSetting, 'iEMobileFirst'),
          b: this.getValueFromObj(this.initialCaratSetting, 'iESecondaryImages'),
          c: this.getValueFromObj(this.initialCaratSetting, 'iEVideo'),
        }
      }
  },
  data() {
    return { 
      name: '',
      selectedImg: require(`../assets/gallary/${this.$route.query.name == 'Device' ? 'rccar/' :''}item1.jpg`),
      showModal: false,
      showVideo: false,
      hideMFHotspot: false,
      relatedProducts: [],
      bigImage: require('../assets/basic.png'),
      productDetailList: this.$route.query.name == 'Battery' ? 
        {
            title: 'Duracell Optimum AA Alkaline Batteries',
            optimoizedTitle: ', 1.5 V LR06 MX1500, Pack of 12',
            formCompany: 'Duracell',
            reviews: '15,247',
            rrPrice: '32.50',
            price: '29.99',
            youSave: '7.51(32%)',
            sku: 'B07RSH9NP7',
            desc: [
                'Proprietary cathode with 2 active ingredients',
                'Duracell Optimum AAA batteries provides Up to 100% Extra Life* or Extra Power* so that you get the best performance from devices.',
                'EXTRA LIFE = Duracell Optimum will last longer in some devices like toys*  ',
                '*Delivers extra life in AAA-size batteries compared to the Minimum Average Duration of the 2015 IEC Toy test. For more info: Duracell’s website',
                'EXTRA POWER = In other devices Duracell Optimum will deliver more power* than previous Duracell Alkaline to make them work better ( e.g. Spinmaster Monster Jam truck  1:24).',
                '*Extra Power in a wide range of devices vs. next best Duracell alkaline AAA. Duracell’s website',
                'OPTIMUM STORAGE: Optimum’s pack keeps new batteries in place and allows secure storage of used ones for recycling',
                '100% RECYCLABLE PACKAGING: Optimum’s packaging is 100% recyclable and 0% plastic',
                '*Delivers extra life in AAA-size batteries compared to the Minimum Average Duration of the 2015 IEC toy test or extra power in a wide range of devices vs. next best Duracell alkaline AAA. Results may vary by device or usage pattern. (IEC’s website). For more info: Duracell’s website',
            ],
            additionalItem: {
                img: require('../assets/additional.jpg'),
                title: 'Additional item to go with this product:',
                subtitle: 'Up to 15% off Gift Cards from Top Brands',
                desc: 'Great deals from top brands iTunes, New Look, Dining Out, Footlocker and many more. Buy now',
                price: '6.99€'
            },
            productDesc: "New Duracell Optimum. Our Best performing AAA alkaline battery <br /> Duracell’s most groundbreaking innovation yet, the all new Duracell Optimum alkaline battery has a new cathode system that can deliver up to 100% Extra Life in some devices, or Extra Power in other devices¹. <br /> <br /> Extra Life:  Duracell Optimum AAA lasts longer in some devices like toys². And long-lasting batteries mean long lasting enjoyment for all device users.  <br /> <br /> Extra Power:  Or Duracell Optimum AAA delivers more power than other Duracell Alkaline batteries in a wide range of devices³ – e.g. motors run faster in devices like some remote controlled cars (Spinmaster Monster Jam official grave digger remote control truck car 1:24 scale)⁴.<br /> <br /> Optimum Performance meets Optimum Packaging<br /> Optimum’s new and innovative ‘book’ style pack has a door and an organiser tray inside, which finally means no more batteries rolling around the kitchen drawer! Instead your batteries remain conveniently and securely stored until you are ready to use them. And once batteries are exhausted, you can re-store them, ready for future recycling.<br /> The packaging is 100% recyclable and 0% plastic.<br /> <br /> Duracell Optimum. Extra Life or Extra Power¹<br /> <br /> Optimum batteries are available in AA, AAA formats.<br /> <br /> 1 Delivers extra life in AAA-size batteries compared to the Minimum Average Duration of the 2015 IEC toy test OR extra power in a wide range of devices vs. next best Duracell alkaline AAA. Results may vary by device or usage pattern. (www.iec.ch). For more info: Duracell’s website<br /> 2 Delivers extra life in AAA-size batteries compared to the Minimum Average Duration of the 2015 IEC Toy test<br /> 3 Delivers extra power in a wide range of devices vs. next best Duracell alkaline AAA. For more info: Duracell’s website<br /> 4 Delivers Extra Power in the Spin Master Monster Jam Official Grave Digger Remote Control Monster Truck, 1:24 Scale, 2.4 GHz, Product Number 6047111/604495 vs. next best Duracell alkaline AA. Results may vary by device or usage pattern. For more info: Duracell’s website<br />",
            images : [
                require('../assets/gallary/1.jpg'),
                require('../assets/gallary/2.jpg'),
                require('../assets/gallary/3.jpg'),
                require('../assets/gallary/4.jpg'),
                require('../assets/gallary/5.jpg'),
            ],
            bigImage: [
                require('../assets/gallary/big1.jpg'),
                require('../assets/gallary/2.jpg'),
                require('../assets/gallary/3.jpg'),
                require('../assets/gallary/4.jpg'),
                require('../assets/gallary/5.jpg'),
            ]

        } : 
        {
            title: 'Monster Jam Authentic Grave Digger RC',
            optimoizedTitle: ', 1:24 Scale, 2.4 GHz, for Ages 4 and Up',
            formCompany: 'Monster Jam',
            reviews: '12,846',
            rrPrice: '17.49€',
            price: '15.96€',
            youSave: '1.53€ (2%)',
            sku: 'B07RSH9NP7',
            desc: [
                'OFFICIAL GRAVE DIGGER: Your 1: 24 scale Grave Digger is an official Monster Jam truck! It comes complete with official sponsor BKT Tires and a look-alike chassis making your monster truck look like the real thing!',
                'COLLECT THEM ALL: Collect the entire line of official Monster Jam RC monster trucks! Create your very own Monster Jam rally using the latest, most realistic trucks! Who will be crowned champion? There’s only one way to find out!',
                'COLLECT THEM ALL: Collect the entire line of official Monster Jam RC monster trucks! Create your very own Monster Jam rally using the latest, most realistic trucks! Who will be crowned champion? There’s only one way to find out!',
                'NEW & IMPROVED TECH: For the first time ever, 2.4GHz allows you to race up to 6 Monster Jam trucks at a time! Now it’s even easier to host your own Monster Jam rally with your friends!',
                'The all-new Grave Digger 1: 24 scale RC toy is the ultimate gift for kids and Monster Jam fans! Get yours today! Batteries not included. Requires 5 AAA batteries.'
            ],
            additionalItem: {
                img: require('../assets/additional.jpg'),
                title: 'This devices requires',
                subtitle: 'Duracell Ultra AAA Alkaline Batteries [Pack of 5], 1.5 V LR03 MN2400 ',
                desc: 'Total price:',
                price: '6.99€'
            },
            productDesc: "Take control of one of the most decorated Monster Jam trucks of all time! Introducing the all-new, official 1: 24 scale grave digger RC! Dig in and drive This heavy-duty Monster truck to the Max to perform epic stunts, crazy crashes and brutal bashes! Featuring 2.4 GHz, you can race up to 6 Monster Jam trucks at a time! Now it’s even easier to host your very own Monster Jam rally with friends! And with a range of up to 250 ft., this 1: 24 scale grave digger RC can dig in anywhere – make the world your very own Monster Jam arena! Authentically styled, this realistic grave digger remote control Monster truck comes with official bkt tires and a look-alike chassis, making sure this iconic truck always delivers big fun! Nothing will stop it from dominating the Monster Jam circuit! This grave digger RC is like driving the real thing! Perform high-octane stunts like big air, donuts, cyclones and more! You’ve never been this close to the Monster Jam action than with the official, all-new Monster Jam 1: 24 scale grave digger RC! <br /><br /> Safety Warning <br /><br /> Not suitable for children aged 4 years and above",
            images : [
                require('../assets/gallary/rccar/1.png'),
                require('../assets/gallary/rccar/2.png'),
                require('../assets/gallary/rccar/3.png'),
                require('../assets/gallary/rccar/4.png'),
                require('../assets/gallary/rccar/5.png'),
                require('../assets/gallary/rccar/6.png'),
                require('../assets/gallary/rccar/7.png'),
            ],
            bigImage: [
                require('../assets/gallary/rccar/rcbig.png'),
                require('../assets/gallary/rccar/2.png'),
                require('../assets/gallary/rccar/3.png'),
                require('../assets/gallary/rccar/4.png'),
                require('../assets/gallary/rccar/5.png'),
                require('../assets/gallary/rccar/6.png'),
                require('../assets/gallary/rccar/7.png'),
            ]

        }
    }
  },
  mounted() {
    const {id} = this.$route.params;
    this.getProductDetail(id);
  },
  watch: {
    productDetails() {
        this.relatedProducts = this.productDetails.related_products
        this.bigImage = this.productDetails['mobile_first_image'];
    },
    
    imageNum() {
      this.hideMFHotspot = true;
      if(this.getValueFromObj(this.initialCaratSetting, 'iEVideo') == false) {
          this.showVideo = false
      }
      if(this.getValueFromObj(this.initialCaratSetting, 'iEMobileFirst') == false) {
        if(this.getValueFromObj(this.initialCaratSetting, 'iESecondaryImages') == false) {
          this.bigImage = this.productDetails['primary_image']
        } else {
          this.bigImage = this.productDetails.primary_image ? this.productDetails.primary_image: require('../assets/basic.png')
        }
      }else {
        this.hideMFHotspot = true;
        this.showVideo = false
        this.bigImage = this.productDetails['mobile_first_image'];
      }
    }
  },
  methods: {
    ...authMethods,
    closeModal() {
      $(".video_container video").get(0).pause();
      this.showModal = false;
    },
    calculatePrice(a, b) {
        return parseInt(a) + parseInt(b);
    },
    changeBigImage(item, a) {
      $('.pd_images_thumb_ul li').removeClass("selected");
      $('.pd_images_thumb_ul li').each(function () {
         $(this).find('img').removeClass("selected")
      })
      a.target.classList.add("selected");
      this.showVideo = false;
      
      if(item == "mobile_first_image")
        this.bigImage = this.productDetails[item]
      else
        this.bigImage = item;
    },
    dataChange( img ) {
        this.bigImage = img;
    },
    selecting(current) {
      $('.img_thumb_list ul li').removeClass("selected");
      $('.img_thumb_list ul').find(`[data-for='${current}']`).addClass("selected");
      try {
        this.selectedImg = require(`../assets/gallary/${this.$route.query.name== 'Device' ? 'rccar/' : ''}${current}.jpg`);
      } catch (e) {
        this.selectedImg = require(`../assets/gallary/big2.jpg`);
      }
      
    }
  } 
}
</script>

<style scoped lang="scss">

</style>

